import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
  constructor(private tokenStorage: TokenStorageService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  const token = this.tokenStorage.getToken();
  if (token && this.tokenStorage.isExpired()) {
    this.tokenStorage.signOut();
    this.router.navigate(['/admin-login'], { queryParams: { returnUrl: '/admin' } });
    return false;
  }
  const user = this.tokenStorage.getUser();
  const roles: string[] = user?.roles || [];
  const isAdmin = !!token && roles.includes('ROLE_APPLISOUND_ADMIN');
  if (isAdmin) {
    this.tokenStorage.updateActivity();
    return true;
  }
  this.router.navigate(['/admin-login'], { queryParams: { returnUrl: '/admin' } });
    return false;
  }
}
